import { getSuccessActionName } from "./make-action";
import TopLevelMethod from "./TopLevelMethod";
import ViewerMethod from "./ViewerMethod";
import {
  getPreferenceItem,
  isValidPreferenceItem,
  PreferencesItem,
} from "../features/preferences/utils";
import { EmptyObject } from "../../../../../common/utils/object";
import deepEqual from "fast-deep-equal";

export function persistReducer(
  key: string,
  reducer: any,
  {
    stateToStorage = (state) => state,
    storageToState = (value) => value,
    byBook = false,
    version = 0,
    migrate = (value, from: number, to: number) => value,
  } = {}
): any {
  let storedInfo: PreferencesItem | EmptyObject | undefined;
  let restored = false;
  return function (state, action) {
    // persistReducer only called once ever per reducer, so need to reset
    // on redux initialization (occurs with multiple book loads in a react
    // app session)
    if (action.type === "@@INIT") {
      storedInfo = undefined;
      restored = false;
    }

    if (
      (byBook &&
        action.type === getSuccessActionName(ViewerMethod.GET_BOOK_INFO)) ||
      (!byBook &&
        action.type === getSuccessActionName(TopLevelMethod.GET_USER_INFO))
    ) {
      const basePrefs = action.resultData.preferences || {};
      storedInfo = basePrefs[key] || {};
    }

    const isReady = !!storedInfo;
    if (isReady && !restored) {
      restored = true;
      if (isValidPreferenceItem(storedInfo)) {
        const isUp = storedInfo.version < version;
        const step = isUp ? +1 : -1;
        for (
          let i = storedInfo.version;
          (isUp ? i < version : i > version) && storedInfo.value;
          i += step
        ) {
          // if a migration fails it returns null and state is reset
          storedInfo.value = migrate
            ? migrate(storedInfo.value, i, i + step)
            : null;
        }
        if (storedInfo.value) {
          return storageToState(storedInfo.value);
        }
      }
    }

    const result = reducer(state, action);
    const toPersist = stateToStorage(result);
    if (isReady && !deepEqual(stateToStorage(state), toPersist)) {
      // UNMEDIATED JIGSAW CALL! NOT NORMAL! DO NOT COPY THIS PATTERN!
      // API calls should go through the mosaic middleware. This code used to
      // interface with local storage. This is the most straightforward way
      // to change it to something jigsaw-based.
      const apiMethod = byBook
        ? window.Viewer.Book.updateUserPreferences
        : window.Jigsaw.User.updatePreferences;
      const valueToStore: PreferencesItem | EmptyObject = toPersist
        ? getPreferenceItem(toPersist, version)
        : {};
      apiMethod({ [key]: valueToStore });
    }
    return result;
  };
}
